import { RouteNames } from "src/routes/routeName";
import {
  Col,
  Result,
  Row,
} from "antd";
import TranslationKey from "src/i18n/translation";

export default function FailedOrder() {

  return (
    <>
    <Row className="mt-4 mb-4">
      <Col span={16} offset={4}>
        <Result
            status="error"
            title={TranslationKey('failedOrder.failedPurchased')}
            subTitle={TranslationKey('failedOrder.failedPurchase')} 
            className="result-order"
            extra={[
              <a
                  href={RouteNames.home}
                  className="btn-orange-round"
                  style={{ textDecoration: "none" }}
                >
                  {TranslationKey('failedOrder.goToHome')}
                </a>
            ]}
          />
      </Col>
    </Row>
    </>
  );
}
